<template>
  <div class="chat-message">
    <p class="small white" v-html="t('alert_message_end_call')"></p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped lang="scss">
.chat-message {
  position: relative;
  display: flex;
  width: fit-content;
  align-self: center;
  align-items: flex-start;
  max-width: 24rem;
  padding: 0.75rem 1rem;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
  background-color: var(--surface-glass-dark);
  outline: 1px solid var(--surface-glass-lightdimmer);
  border-radius: 8px;
}
</style>
